var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouteIconsVertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 62,
    viewBox: "0 0 16 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 46.6667C11.1293 46.6667 13.6663 49.2038 13.6663 52.3334C13.6663 54.3238 12.7478 56.3365 11.2122 58.3005C10.6672 58.9975 10.0745 59.6474 9.46725 60.2394C9.41722 60.2881 9.36803 60.3356 9.31972 60.3818L9.04109 60.6432L8.78675 60.8724L8.55957 61.0686L8.42083 61.1835C8.17737 61.3819 7.82845 61.3835 7.58321 61.1873L7.43815 61.0672L7.21201 60.8719L6.95813 60.6431L6.67962 60.3818L6.5321 60.2394C5.92488 59.6474 5.33215 58.9975 4.78715 58.3005C3.25154 56.3365 2.33301 54.3238 2.33301 52.3334C2.33301 49.2038 4.87005 46.6667 7.99967 46.6667ZM7.99967 48.0001C5.60643 48.0001 3.66634 49.9402 3.66634 52.3334C3.66634 53.9708 4.4682 55.7279 5.83752 57.4792C6.34307 58.1258 6.8961 58.7322 7.46283 59.2846L7.73131 59.5415C7.81977 59.6245 7.90835 59.7076 7.99967 59.7874L8.268 59.5415L8.53652 59.2846C9.10324 58.7322 9.65627 58.1258 10.1618 57.4792C11.5311 55.7279 12.333 53.9708 12.333 52.3334C12.333 49.9402 10.3929 48.0001 7.99967 48.0001ZM7.99967 49.6667C9.47243 49.6667 10.6663 50.8607 10.6663 52.3334C10.6663 53.8062 9.47243 55.0001 7.99967 55.0001C6.52692 55.0001 5.33301 53.8062 5.33301 52.3334C5.33301 50.8607 6.52692 49.6667 7.99967 49.6667ZM7.99967 51.0001C7.2633 51.0001 6.66634 51.597 6.66634 52.3334C6.66634 53.0698 7.2633 53.6667 7.99967 53.6667C8.73605 53.6667 9.33301 53.0698 9.33301 52.3334C9.33301 51.597 8.73605 51.0001 7.99967 51.0001Z",
    fill: "#0088E7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17L8 46",
    stroke: "white",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteIconsVertical);
export default __webpack_public_path__ + "static/media/route-icons-vertical.92c00e548b27497a36038f937b14ff56.svg";
export { ForwardRef as ReactComponent };